import { real_estate } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export const findRealEstate =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    personID,
    includeAll,
    ids,
  }: {
    personID?: string;
    includeAll?: boolean;
    ids?: string[];
  }): Promise<real_estate.RealEstate[]> =>
    send({
      baseURL,
      token,
      path: '/real-estate',
      method: 'GET',
      searchParams: {
        person_id: personID,
        id: ids,
        include_all: includeAll,
      },
    });

export const createRealEstate =
  ({ token, url: { service: baseURL } }: IAPI) =>
  (body: real_estate.CreateRealEstate): Promise<real_estate.RealEstate> =>
    send({
      baseURL,
      token,
      path: '/real-estate',
      method: 'POST',
      body,
    });

export const patchRealEstate =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    id,
    patch,
  }: {
    id: string;
    patch: real_estate.PatchRealEstate;
  }): Promise<real_estate.RealEstate> =>
    send({
      baseURL,
      token,
      path: `/real-estate/${encodeURIComponent(id)}`,
      method: 'PATCH',
      body: patch,
    });

export const deleteRealEstate =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({ id }: { id: string }): Promise<void> =>
    send({
      baseURL,
      token,
      path: `/real-estate/${encodeURIComponent(id)}`,
      method: 'DELETE',
    });

export const getLoanApplicationCollateral =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    applicationID,
  }: {
    applicationID: string;
  }): Promise<real_estate.LoanApplicationCollateral[]> =>
    send({
      baseURL,
      token,
      path: `/loan-application/${encodeURIComponent(applicationID)}/collateral`,
      method: 'GET',
    });

export const addLoanApplicationCollateral =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    applicationID,
    estateID,
  }: {
    applicationID: string;
    estateID: string;
  }): Promise<real_estate.LoanApplicationCollateral> =>
    send({
      baseURL,
      token,
      path: `/loan-application/${encodeURIComponent(applicationID)}/collateral`,
      method: 'POST',
      body: {
        RealEstateID: estateID,
      },
    });

export const removeLoanApplicationCollateral =
  ({ token, url: { service: baseURL } }: IAPI) =>
  ({
    applicationID,
    collateralID,
  }: {
    applicationID: string;
    collateralID: string;
  }): Promise<void> =>
    send({
      baseURL,
      token,
      path: `/loan-application/${encodeURIComponent(applicationID)}/collateral/${encodeURIComponent(collateralID)}`,
      method: 'DELETE',
    });
